// extracted by mini-css-extract-plugin
export default {"cls1":"QNZpENrxzu3saPUOot_b","cls2":"WG9CrWFQkfUWz5sFfChP QNZpENrxzu3saPUOot_b"};